import axios from "../../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    try {
      const response = await axios.get("/auth/refresh");

      setAuth((prev) => {
        return {
          ...prev,
          // user: response.data.user,
          accessToken: response.data.accessToken,
        };
      });

      return response.data.accessToken;
    } catch (error) {
      console.error(error);
    }

    return "";
  };

  return refresh;
};

export default useRefreshToken;
